import { Link } from "react-router-dom";
import { EMAILS, STUDIO_INFO } from "@/lib/brand";
import { Mail, Instagram, Facebook, Music2 } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative border-t border-white/10 bg-[#08080A] mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-display font-black text-xl tracking-[0.15em]">
            AL<span className="text-gold">MUSIC</span>
            <div className="text-xs font-light tracking-[0.3em] text-slate-500 mt-1">RECORDS</div>
          </div>
          <p className="text-sm text-slate-500 mt-4 leading-relaxed">
            Production musicale & phonographique, studio, mixage/mastering, audiovisuel, booking et projets culturels.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href={STUDIO_INFO.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-gold hover:border-amber-400/40 transition"><Instagram size={17} /></a>
            <a href={STUDIO_INFO.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-gold hover:border-amber-400/40 transition"><Facebook size={17} /></a>
            <a href={STUDIO_INFO.tiktok} target="_blank" rel="noreferrer" data-testid="footer-tiktok" aria-label="TikTok" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-gold hover:border-amber-400/40 transition"><Music2 size={17} /></a>
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Navigation</div>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/services/production-musicale" className="hover:text-gold">Production musicale</Link></li>
            <li><Link to="/studio" className="hover:text-gold">Studio</Link></li>
            <li><Link to="/artistes" className="hover:text-gold">Artistes & Projets</Link></li>
            <li><Link to="/booking" className="hover:text-gold">Booking</Link></li>
            <li><Link to="/projets-culturels" className="hover:text-gold">Projets culturels</Link></li>
            <li><Link to="/actualites" className="hover:text-gold">Actualités</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Contacts</div>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2"><Mail size={15} className="text-gold mt-0.5" /><a href={`mailto:${EMAILS.contact}`} className="hover:text-gold break-all">{EMAILS.contact}</a></li>
            <li className="flex items-start gap-2"><Mail size={15} className="text-gold mt-0.5" /><a href={`mailto:${EMAILS.management}`} className="hover:text-gold break-all">{EMAILS.management}</a></li>
            <li className="flex items-start gap-2"><Mail size={15} className="text-gold mt-0.5" /><a href={`mailto:${EMAILS.studio}`} className="hover:text-gold break-all">{EMAILS.studio}</a></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Informations</div>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/mentions-legales" className="hover:text-gold">Mentions légales</Link></li>
            <li><Link to="/confidentialite" className="hover:text-gold">Politique de confidentialité</Link></li>
            <li><Link to="/cgv" className="hover:text-gold">CGV</Link></li>
            <li><Link to="/conditions-reservation" className="hover:text-gold">Conditions de réservation</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-slate-600">
        © {new Date().getFullYear()} AL MUSIC RECORDS — Tous droits réservés.
      </div>
    </footer>
  );
}
